import Stack, { type StackProps } from '@mui/material/Stack'

export const VStack = (props: StackProps) => {
  return <Stack direction="column" {...props} />
}

export type { StackProps as VStackProps }
